export enum SessionStatus {
    Active = 0,
    ReloginPrompt = 1,
    LogoutPrompt = 2,
    DuplicateSession = 3
}
